import OnlineUsersService from '../services/OnlineUsersService';

export class OnlineUsersDisplay {
  private onlineService: OnlineUsersService;
  private displayElement: HTMLElement | null = null;
  
  constructor() {
    this.onlineService = OnlineUsersService.getInstance();
  }
  
  public initialize(): void {
    // Create the display element
    this.displayElement = document.createElement('div');
    this.displayElement.id = 'online-users-display';
    this.displayElement.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 20px;
      background: rgba(0, 0, 0, 0.8);
      border: 2px solid #4CAF50;
      border-radius: 8px;
      padding: 10px 15px;
      color: white;
      font-family: Arial, sans-serif;
      font-size: 14px;
      z-index: 60000;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s ease;
      cursor: default;
    `;
    
    // Add hover effect
    this.displayElement.onmouseover = () => {
      if (this.displayElement) {
        this.displayElement.style.background = 'rgba(0, 0, 0, 0.9)';
        this.displayElement.style.transform = 'scale(1.05)';
      }
    };
    
    this.displayElement.onmouseout = () => {
      if (this.displayElement) {
        this.displayElement.style.background = 'rgba(0, 0, 0, 0.8)';
        this.displayElement.style.transform = 'scale(1)';
      }
    };
    
    // Set initial content
    this.updateDisplay(0);
    
    // Add to page
    document.body.appendChild(this.displayElement);
    
    // Start tracking this user as online
    this.onlineService.startTracking();
    
    // Subscribe to online count updates
    this.onlineService.subscribeToOnlineCount((count) => {
      this.updateDisplay(count);
    });
  }
  
  private updateDisplay(count: number): void {
    if (!this.displayElement) return;
    
    // Create online indicator dot
    const dotColor = count > 0 ? '#4CAF50' : '#666';
    const pulseAnimation = count > 0 ? `
      @keyframes pulse {
        0% { opacity: 1; }
        50% { opacity: 0.5; }
        100% { opacity: 1; }
      }
    ` : '';
    
    // Add animation styles if not already added
    if (count > 0 && !document.getElementById('online-pulse-style')) {
      const style = document.createElement('style');
      style.id = 'online-pulse-style';
      style.textContent = pulseAnimation;
      document.head.appendChild(style);
    }
    
    this.displayElement.innerHTML = `
      <div style="
        width: 10px;
        height: 10px;
        background: ${dotColor};
        border-radius: 50%;
        ${count > 0 ? 'animation: pulse 2s infinite;' : ''}
      "></div>
      <span style="font-weight: bold; color: #4CAF50;">Users Online:</span>
      <span style="color: white; font-weight: bold;">${count}</span>
    `;
  }
  
  public destroy(): void {
    if (this.displayElement) {
      this.displayElement.remove();
      this.displayElement = null;
    }
    
    // Stop tracking when display is destroyed
    this.onlineService.stopTracking();
  }
}

export default OnlineUsersDisplay;